module.exports = __webpack_public_path__ + "static/media/header_bg_2.53b0d670.jpg";